<template>
    <div class="page">
        <div class="page-content">
           
            <el-card class="box-card" header="历史资金数据" style="margin-top: 20px; height: 1000px;">
                <!-- 搜索 -->
                <el-form  :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
                    <el-form-item label="当天日期">
                        <!--<el-input  v-model="queryForm.dayDate"></el-input>-->
                        <el-date-picker
                            style="width: 177px;"
                            size="small"
                            v-model="queryForm.dayDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" icon="el-icon-search" @click="getShopUtilDataList">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
                    </el-form-item>
                </el-form>

                <!-- 列表数据 -->
                <el-table
                :data="shopUtilDataList"
                row-key="id"
                border
                width="100%"
                height="700px"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
                >
                    <el-table-column prop="dayDate" label="日期" width="300" align="center"></el-table-column>
                    <el-table-column prop="money1" label="累计可用消费券" width="300" align="center"></el-table-column>
                    <!-- <el-table-column prop="money2" label="累计补贴凭证" width="300" align="center"></el-table-column> -->
                    <!-- <el-table-column prop="money3" label="累计补贴消费券" width="300" align="center"></el-table-column> -->
                    <!-- <el-table-column prop="money4" label="累计补贴市场" width="300" align="center"></el-table-column> -->
                    <!-- <el-table-column prop="money5" label="累计补贴动券宝" width="300" align="center"></el-table-column> -->
                    <!-- <el-table-column prop="createTime" label="创建时间" width="300" align="center"></el-table-column> -->
                </el-table>

                <div class="pagination-box">
                    <el-pagination
                        @size-change="sizeChange"
                        @current-change="currentChange"
                        :current-page.sync="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalNum"
                        background
                        :pager-count="7"
                    >
                    </el-pagination>
                </div>
            </el-card>

        </div>
    </div>
</template>

<script>
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
export default {

    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopUtilDataList(); //重置列表数据
                this.getShopUtilDataList(this.queryForm); //查询历史资金数据
                this.$emit('resetCheckState'); 
            } else if (val == 'reset') {
                this.resetShopUtilDataList();
                this.getShopUtilDataList();
                this.$emit('resetCheckState');
            }
        }
    },

    data() {
        return {
            queryForm:{
                dayDate: '', //日期
                money1: '',//系统可用消费券
                money2: '',//系统消费券额度
                money3: '',//系统动券宝额度
                money4: '',//累计补贴消费券
                money5: '' //累计补贴动券宝
            },
            shopUtilDataList: [
                {
                    dayDate: '2025-10-01', //日期
                    money1: '10',//系统可用消费券
                    money2: '20',//系统消费券额度
                    money3: '30',//系统动券宝额度
                    money4: '40',//累计补贴消费券
                    money5: '50' //累计补贴动券宝
                },
            ],
            totalNum: 0,
            pageSize: 10,
            currentPage: 1,
            multipleSelection: [],
            getSystemAllMoney: {
                money1: 0,//系统可用消费券
                money2: 0,//系统消费券额度
                money3: 0,//系统动券宝额度
                money4: 0,//累计补贴消费券
                money5: 0//	累计补贴动券宝
            },
			
			subsidyData:{
				incomeVoucher:0,
				firstRatio:0,
				firstSubsidy:0,
				
				lastSubsidy:0,
				incrementRatio:0,
				currentMoney:0,
				
				currentAvaliable:0,
				
				sendStatus:0,
				subsidyStatus:0
				
			}
        };
    },
    created() {
        this.getShopUtilDataList();
    },
    methods: {
        resetDialog() {
            this.operationDailyGlobalDataState = 'add';
            this.queryForm = {
                    dayDate: '', //
                    money1: '',//系统可用消费券
                    money2: '',//系统消费券额度
                    money3: '',//系统动券宝额度
                    money4: '',//累计补贴消费券
                    money5: '' //累计补贴动券宝
            };
            this.getShopUtilDataList();
        },

        getShopUtilDataList(){
            this.loading = true;
            get(`/shop/utildata/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopUtilDataList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },

        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopUtilDataList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopUtilDataList();
        }

    }


};
</script>

<style scoped lang="scss">
::v-deep .el-input__inner{
    padding: 0 5px;
    text-align: center;
}
::v-deep .el-radio{
    margin-right: 10px;
}
</style>